<template>
  <!--<textarea
    ref="textarea"
    class="lg:pt-1 px-1 flex-1 rounded-l"
    :value="value"
    @keyup="setAutoHeight"
    @click.stop.prevent="$emit('text-entry-clicked')"
    @input="$emit('input', $event.target.value)"
  ></textarea>-->
  <input
    type="text"
    class="px-1 flex-1 border-0"
    :class="{ 'cursor-default bg-gray-200' : disabled, 'line-through' : !active }"
    :value="value"
    :disabled="disabled"
    @click.stop.prevent="$emit('text-entry-clicked')"
    @input="$emit('input', $event.target.value)" />
</template>

<script>
//import Vue from "Vue";

export default {
  name: 'SortTextEntry',
  props: {
    value: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: true
    },
  },
  methods: {
    setAutoHeight() {
      this.$el.style.height = 'inherit';

      var computed = window.getComputedStyle(this.$el);
      var height =
        parseInt(computed.getPropertyValue('border-top-width'), 10) +
        parseInt(computed.getPropertyValue('padding-top'), 10) +
        this.$el.scrollHeight +
        parseInt(computed.getPropertyValue('padding-bottom'), 10) +
        parseInt(computed.getPropertyValue('border-bottom-width'), 10);
      this.$el.style.height = height + 'px';
    }
  },
  mounted() {
    //this.setAutoHeight();
  }
};
</script>
